import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IEMVDataFormMeta {
  // Application Data
  iccApplication: FormInputMeta;
  applicationExpiryDate: FormInputMeta;
  applicationStartDate: FormInputMeta;
  applicationTransactionCounter: FormInputMeta;
  // Application interchange profile
  offlineSDA: FormInputMeta;
  terminalRiskManagement: FormInputMeta;
  offlineDDA: FormInputMeta;
  issuerAuthentication: FormInputMeta;
  cardHolderVerification: FormInputMeta;
  combinedDdaAcGeneration: FormInputMeta;
  // Terminal Data
  terminalId: FormInputMeta;
  terminalSerialNumber: FormInputMeta;
  terminalCountryCode: FormInputMeta;
  transactionDate: FormInputMeta;
  // Terminal capability
  manualKeyEnter: FormInputMeta;
  onlinePinAllowed: FormInputMeta;
  magneticStripeRead: FormInputMeta;
  signatureAllowed: FormInputMeta;
  chipRead: FormInputMeta;
  sdaSupported: FormInputMeta;
  offlinePinAllowed: FormInputMeta;
  cardCapture: FormInputMeta;
  // Cryptogram
  currencyCode: FormInputMeta;
  transactionType : FormInputMeta;
  ARPCResponse: FormInputMeta;
  transactionAmount: FormInputMeta;
  cashBackAmount: FormInputMeta;
  predictableNumber: FormInputMeta;
  derivationKeyIndex: FormInputMeta;
  arqc: FormInputMeta;
  arpc: FormInputMeta;
  cryptogramVersion: FormInputMeta;
  issuerScriptResult: FormInputMeta;


  schema: any;
}

const EMVDataFormMeta = {} as IEMVDataFormMeta;
// Application Data
  EMVDataFormMeta.iccApplication = {
    name: 'iccApplication',
    type: 'text',
    label: 'ICC Application',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  EMVDataFormMeta.applicationExpiryDate = {
    name: 'applicationExpiryDate',
    type: 'text',
    label: 'Date d\'expiration de la demande',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  EMVDataFormMeta.applicationStartDate = {
    name: 'applicationStartDate',
    type: 'text',
    label: 'Date de début de l\'application',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  EMVDataFormMeta.applicationTransactionCounter = {
    name: 'applicationTransactionCounter',
    type: 'text',
    label: 'Demande compteur de transactions',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },

  // Application interchange profile
  EMVDataFormMeta.offlineSDA = {
    name: 'offlineSDA',
    type: 'checkbox',
    label: 'SDA hors ligne',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  EMVDataFormMeta.terminalRiskManagement = {
    name: 'terminalRiskManagement',
    type: 'checkbox',
    label: 'Gestion des risques au niveau des terminaux',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.offlineDDA = {
    name: 'offlineDDA',
    type: 'checkbox',
    label: 'DDA hors ligne',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.issuerAuthentication = {
    name: 'issuerAuthentication',
    type: 'checkbox',
    label: 'Authentification de l\'émetteur',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.cardHolderVerification = {
    name: 'cardHolderVerification',
    type: 'checkbox',
    label: 'Vérification du titulaire de la carte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.combinedDdaAcGeneration = {
    name: 'combinedDdaAcGeneration',
    type: 'checkbox',
    label: 'Génération combinée DDA/AC',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }

  // Terminal Data  
  EMVDataFormMeta.terminalId = {
    name: 'terminalId',
    type: 'text',
    label: 'Id terminal',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.terminalSerialNumber = {
    name: 'terminalSerialNumber',
    type: 'text',
    label: 'Numéro de série du terminal',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.terminalCountryCode = {
    name: 'terminalCountryCode',
    type: 'text',
    label: 'Code pays du terminal',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.transactionDate = {
    name: 'transactionDate',
    type: 'text',
    label: 'Date de la transaction',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }

  // Terminal capability
  EMVDataFormMeta.manualKeyEnter = {
    name: 'manualKeyEnter',
    type: 'checkbox',
    label: 'Manuel entrée par touche',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.onlinePinAllowed = {
    name: 'onlinePinAllowed',
    type: 'checkbox',
    label: 'Pin autorisé en ligne',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.magneticStripeRead = {
    name: 'magneticStripeRead',
    type: 'checkbox',
    label: 'Lecture de la bande magnétique',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.signatureAllowed = {
    name: 'signatureAllowed',
    type: 'checkbox',
    label: 'Signature autorisée',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.chipRead = {
    name: 'chipRead',
    type: 'checkbox',
    label: 'Lecture de la puce',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.sdaSupported = {
    name: 'sdaSupported',
    type: 'checkbox',
    label: 'SDA pris en charge',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.offlinePinAllowed = {
    name: 'offlinePinAllowed',
    type: 'checkbox',
    label: 'Hors ligne Pin autorisé',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.cardCapture = {
    name: 'cardCapture',
    type: 'checkbox',
    label: 'Capture de la carte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  
  // Cryptogram
  
  EMVDataFormMeta.currencyCode = {
    name: 'currencyCode',
    type: 'text',
    label: 'Code de la devise',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.transactionType = {
    name: 'transactionType',
    type: 'text',
    label: 'Type de transaction',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.ARPCResponse = {
    name: 'ARPCResponse',
    type: 'text',
    label: 'Réponse ARPC',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.transactionAmount = {
    name: 'transactionAmount',
    type: 'text',
    label: 'Montant de la transaction',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.cashBackAmount = {
    name: 'cashBackAmount',
    type: 'text',
    label: 'Montant du remboursement en espèces',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.predictableNumber = {
    name: 'predictableNumber',
    type: 'text',
    label: 'Numéro prévisible',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.derivationKeyIndex = {
    name: 'derivationKeyIndex',
    type: 'text',
    label: 'Indice de la clé de dérivation',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.arqc = {
    name: 'arqc',
    type: 'text',
    label: 'ARQC',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.arpc = {
    name: 'arpc',
    type: 'text',
    label: 'ARPC',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.cryptogramVersion = {
    name: 'cryptogramVersion',
    type: 'text',
    label: 'Cryptogramme version',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  EMVDataFormMeta.issuerScriptResult = {
    name: 'issuerScriptResult',
    type: 'text',
    label: 'Emetteur script résultat',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }


EMVDataFormMeta.schema = yup.object().shape(getValidationSchema(EMVDataFormMeta));

export default EMVDataFormMeta;